import { EnvelopeModel } from '@/models/envelopeModel';

export function getSingleFee(envelope: EnvelopeModel, ticket: TicketModel) {
  return +envelope.otherFees > 0 ? +ticket.fee + envelope.otherFees / envelope.tickets.length : +ticket.fee;
}